import React from "react";
import ItemTable from "../../compoments/shopper/item/ItemTable";

export default function Items() {
    return (<ItemTable/>);
}